const locale = {
	// #region Tabs
	TAB_GENERAL: 'General',
	TAB_TRANSLATIONS: 'Translations',
	TAB_CLOSINGDAYS: 'Closing Days',
	TAB_INTEGRATIONS: 'Connectors',
	TAB_JASPERREPORTS: 'Jasper Reports',
	TAB_CARBONE: 'Carbone',
	// #endregion

	// #region General settings tab
	DETAILS_SETTINGS_MAIN_SECTION: 'Settings',
	DETAILS_SETTINGS_MAIN_SUBHEADER: 'Basic application settings',
	SETTINGS_SELF_VATNUMBER: 'Self vatnumber',
	SETTINGS_FILES_PATH: 'Files folder path',
	SETTINGS_DOCS_PATH: 'Docs folder path',
	SETTINGS_DOCS_CUSTOMERS_PATH: 'Customers docs folder path',
	SETTINGS_DOCS_SUPPLIERS_PATH: 'Suppliers docs folder path',
	SETTINGS_REPORTS_STANDARD_ROOT_FOLDER: 'Standard report root folder path',
	SETTINGS_REPORTS_CUSTOM_ROOT_FOLDER: 'Custom report root folder path',
	SETTINGS_REPORTS_DATAADAPTER_PATH: 'Report data adapter path',
	SETTINGS_WORKDAY_TIME_START: 'Generic workday start hour',
	SETTINGS_WORKDAY_TIME_END: 'Generic workday end hour',
	SETTINGS_LUNCH_TIME_START: 'Generic lunch start hour',
	SETTINGS_LUNCH_TIME_END: 'Generic lunch end hour',
	SETTINGS_TIME_MINIMUM_INTERVAL: 'Time minimum interval',
	SETTINGS_ACTIVITIES_EXPIRING_TIER1: 'Activities - Expiring tier 1',
	SETTINGS_ACTIVITIES_EXPIRING_TIER2: 'Activities - Expiring tier 2',
	SETTINGS_OPPORTUNITIES_EXPIRING_TIER1: 'Opportunities - Expiring tier 1',
	SETTINGS_OPPORTUNITIES_EXPIRING_TIER2: 'Opportunities - Expiring tier 2',
	SETTINGS_COMPANIES_VIEW_SECTION_ALL: 'Enables the "All" Companies list',
	SETTINGS_LEAVE_MINIMUM_NOTICE_DAYS: 'Leave - Generic minimum notice',
	SETTINGS_TIME_MINIMUM_LEAVE: 'Permessi - Minimum interval',

	DETAILS_SETTINGS_FILES_SECTION: 'Files settings',
	DETAILS_SETTINGS_FILES_SUBHEADER: 'Settings of the files handled by the application',
	SETTINGS_DOCS_COMPANIES_ENABLED: 'Enables the management of Companies docs',
	SETTINGS_DOCS_ORDERS_ENABLED: 'Enables the management of Orders docs',
	SETTINGS_DOCS_PROJECTS_ENABLED: 'Enables the management of Projects docs',

	DETAILS_SETTINGS_ORDERS_SECTION: 'Orders settings',
	DETAILS_SETTINGS_ORDERS_SUBHEADER: 'Settings to change the behavior of the Orders module',
	SETTINGS_ORDERS_SHIPPING_ENABLED: 'Enables Shipping module',
	SETTINGS_ORDERS_LINES_ITEMS_GROUPED: 'Aggregate Order Lines with the same Product',
	SETTINGS_ORDERS_PRICE_CUSTOM_ENABLED: 'Enables full edit of Order Lines',
	SETTINGS_ORDERS_EXPENSES_MANAGER_ENABLED: 'Enables the management of expenses in the Order Lines',
	SETTINGS_ORDERS_LINES_WORKREPORTS_ENABLED: 'Enables the option to add "Service" type Order Lines',
	SETTINGS_ORDERS_LINES_PROJECTS_ENABLED: 'Enables linking Projects to Orders Lines',
	SETTINGS_ORDERS_LINES_INVOICES_ENABLED: 'Enables linking Invoices to Orders Lines',
	SETTINGS_ORDERS_LINES_STATUS_ENABLED: 'Enables handling the Order Status for each Order Line',
	SETTINGS_ORDERS_EXPIRED_IN_DAYS: 'Validity period',
	SETTINGS_ORDERS_MIN_ORDER_VALUE: 'Minimum Order value',

	SETTINGS_PROJECTS_FINANCIAL_STATS_ENABLED: 'Enables financial stats in Projects details page',

	DETAILS_SETTINGS_INVOICES_SECTION: 'Invoices settings',
	DETAILS_SETTINGS_INVOICES_SUBHEADER: 'Settings to change the behavior of the Invoices module',
	SETTINGS_INVOICES_ROWS_LINK_LINES_ENABLED: 'Enables linking Contracts/Orders Lines to Invoices Rows',
	// #endregion

	// #region Translations settings tab
	DETAILS_SETTINGS_TRANSLATIONS_RESOURCES_SECTION: 'Translations',
	DETAILS_SETTINGS_TRANSLATIONS_RESOURCES_SUBHEADER: 'List of resources used for localization',
	I18N_TABLE_COLUMN_LANGUAGE: 'Language',
	I18N_TABLE_COLUMN_KEY: 'Key',
	I18N_TABLE_COLUMN_MESSAGE: 'Message',
	// #endregion

	// #region Connectors settings tab
	DETAILS_SETTINGS_CREDITSAFE_SECTION: 'Creditsafe',
	DETAILS_SETTINGS_CREDITSAFE_SUBHEADER: 'Settings for Creditsafe integration',
	SETTINGS_CREDITSAFE_USERNAME: 'Username',
	SETTINGS_CREDITSAFE_PASSWORD: 'Password',
	SETTINGS_CREDITSAFE_TEMPLATE: 'Template type',
	SETTINGS_CREDITSAFE_CREDITS: 'Used credits: {value}/{total}',

	DETAILS_SETTINGS_GEOAPIFY_SECTION: 'Geoapify',
	SETTINGS_GEOAPIFY_REST_URL: 'REST url',
	SETTINGS_GEOAPIFY_API_KEY: 'Api key',

	DETAILS_SETTINGS_HEREAPI_SECTION: 'HERE',
	SETTINGS_HERE_REST_URL: 'REST url',
	SETTINGS_HERE_API_KEY: 'Api key',

	DETAILS_SETTINGS_MICROSOFT365_SECTION: 'Microsoft Office 365',
	SETTINGS_MICROSOFT365_CLIENT_ID: 'Client ID',
	SETTINGS_MICROSOFT365_CLIENT_SECRET: 'Client secret',
	SETTINGS_MICROSOFT365_TENANT: 'Tenant',

	DETAILS_SETTINGS_POWERBI_SECTION: 'PowerBI',
	SETTINGS_POWERBI_REDIRECT_URI: 'Redirect URI',

	DETAILS_SETTINGS_EXCHANGEONLINE_SECTION: 'Exchange Online',
	SETTINGS_EXCHANGEONLINE_LINK_ACCOUNT: 'Link account',
	SETTINGS_EXCHANGEONLINE_CHANGE_ACCOUNT: 'Change account',
	SETTINGS_EXCHANGEONLINE_REDIRECT_URI: 'Redirect URI',
	SETTINGS_EXCHANGEONLINE_MAIL_CUSTOMERS_FOLDER_IMPORT: 'Exchange Customers import Mails folder id',
	SETTINGS_EXCHANGEONLINE_MAIL_CUSTOMERS_FOLDER_IMPORTED: 'Exchange Customers imported Mails folder id',
	SETTINGS_EXCHANGEONLINE_MAIL_SUPPLIERS_FOLDER_IMPORT: 'Exchange Suppliers import Mails folder id',
	SETTINGS_EXCHANGEONLINE_MAIL_SUPPLIERS_FOLDER_IMPORTED: 'Exchange Suppliers imported Mails folder id',

	DETAILS_SETTINGS_BILLING_REVISO_SECTION: 'Reviso',
	SETTINGS_REVISO_APP_SECRET_TOKEN: 'Secret token',
	SETTINGS_REVISO_AGREEMENT_GRANT_TOKEN: 'Agreement grant token',

	DETAILS_SETTINGS_BILLING_FATTUREINCLOUD_SECTION: 'FattureInCloud',
	SETTINGS_BILLING_FATTUREINCLOUD_ACCESS_TOKEN: 'Access token',
	SETTINGS_BILLING_FATTUREINCLOUD_COMPANY_ID: 'Company ID',
	// #endregion

	// #region Dashboard Links settings tab
	DIALOG_DASHBOARD_LINKS_TITLE: 'Dashboard Link',
	DIALOG_COMMON_ICON: 'Icon',
	DIALOG_COMMON_URL: 'Url',

	DETAILS_SETTINGS_DASHBOARD_LINKS_SECTION: 'Dashboard Links',
	DETAILS_SETTINGS_DASHBOARD_LINKS_SUBHEADER: 'Settings for links to view in the user dashboard page',
	DETAILS_SETTINGS_DASHBOARD_LINKS_VISIBILITY: 'Visibility level',
	DETAILS_SETTINGS_DASHBOARD_LINKS_VISIBILITY_ROLE: 'User role',
	DETAILS_SETTINGS_DASHBOARD_LINKS_VISIBILITY_GROUP: 'Group',
	DETAILS_SETTINGS_DASHBOARD_LINKS_VISIBILITY_USER: 'User',
	// #endregion

	// #region JasperReports settings tab
	DETAILS_SETTINGS_REPORTS_JASPERREPORTS_SECTION: 'JasperReports settings',
	DETAILS_SETTINGS_REPORTS_JASPERREPORTS_SUBHEADER: 'Settings for JasperReports integration',
	SETTINGS_REPORTS_JASPERREPORTS_STANDARD_ROOT_FOLDER: 'Standard report root folder path',
	SETTINGS_REPORTS_JASPERREPORTS_CUSTOM_ROOT_FOLDER: 'Custom report root folder path',
	SETTINGS_REPORTS_JASPERREPORTS_DATAADAPTER_PATH: 'Report data adapter path',

	DETAILS_SETTINGS_REPORTS_JASPERREPORTS_JOBS_SECTION: 'JasperReports Jobs',
	DETAILS_SETTINGS_REPORTS_JASPERREPORTS_JOBS_SUBHEADER: 'List of all JasperReports Jobs',

	REPORTS_NEXT_EXECUTION: 'Next execution:',
	// #endregion

	// #region Carbone settings section
	DETAILS_SETTINGS_REPORTS_CARBONE_SECTION: 'Carbone',
	DETAILS_SETTINGS_REPORTS_CARBONE_SUBHEADER: 'Settings for Carbone documents generation',
	SETTINGS_REPORTS_CARBONE_REST_URL: 'Rest URL',

	DETAILS_SETTINGS_REPORTS_CARBONE_TEMPLATES_SECTION: 'Templates',
	DETAILS_SETTINGS_REPORTS_CARBONE_TEMPLATES_SUBHEADER: 'Carbone template manager',
	// #endregion

	// #region Closing Days settings section
	CLOSINGDAYS_TITLE: 'Description',
	CLOSINGDAYS_DATE: 'Date',
	CLOSINGDAYS_RECURSIVE: 'Yearly',
	CLOSINGDAYS_CRON: 'Frequency',
	CLOSINGDAYS_TABLE_TITLE: 'Closing days',
	CLOSINGDAYS_TABLE_SUBTITLE_HOLIDAYS: 'Days when the company will be closed for holidays',
	CLOSINGDAYS_TABLE_SUBTITLE: 'Days when the company will be closed for events, special or regular occasion',
	CLOSINGDAYS_HOLIDAYS_TITLE: 'Holidays',
	DAYS: 'Day',
	WEEKS: 'Week',
	MONTHS: 'Month',
	YEAR: 'Year',
	CLOSINGDAYS_EVERY: 'Every'
	// #endregion
};

export default locale;
